export const API_CONST = {
  PROTOCOL: window.location.protocol,
  HOST: window.location.hostname,
  PORT: window.location.port || '443',
  VERSION: 0,
};

export const CLIENT_CONST = {
  INSTITUTE_NAME: process.env.REACT_APP_INSTITUTE || '',
  TITLE: process.env.REACT_APP_TITLE || 'Core',
  RELEASE_NUMBER: process.env.REACT_APP_RELEASE_NUMBER || 'Development',
  AUTH_METHOD: process.env.REACT_APP_AUTH_METHOD || 'local',
  OAUTH_CLIENT_ID: process.env.REACT_APP_OAUTH_CLIENT_ID,
  OAUTH_CLIENT_SECRET: process.env.REACT_APP_OAUTH_CLIENT_SECRET,
  OAUTH_AUTH_URI: process.env.REACT_APP_OAUTH_AUTH_URI,
  OAUTH_LOGOUT_URI: process.env.REACT_APP_OAUTH_LOGOUT_URI || '',
  OAUTH_SCOPE: process.env.REACT_APP_OAUTH_SCOPE,
  OAUTH_RESPONSE_TYPE: process.env.REACT_APP_OAUTH_RESPONSE_TYPE,
  TENURE_TERM: process.env.REACT_APP_TENURE_TERM || 'Tenure',
  MAX_TENURE_LENGTH_MONTHS: process.env.REACT_APP_MAX_TENURE_LENGTH_MONTHS || null,
  DEFAULT_TENURE_LENGTH_MONTHS: process.env.REACT_APP_DEFAULT_TENURE_LENGTH_MONTHS || null,
};

if (window.location.hostname !== process.env.REACT_APP_PRODUCTION_HOST) {
  const hostname = window.location.hostname.split('.')[0];
  CLIENT_CONST.TITLE += ` [${hostname}]`;
} else if (process.env.REACT_APP_PRODUCTION_HOST_SUBTITLE) {
  CLIENT_CONST.TITLE += ` [${process.env.REACT_APP_PRODUCTION_HOST_SUBTITLE}]`;
}

export const DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  // timeZone: 'UTC',
  // weekday: 'short',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
};

export const DATE_TIME_OPTIONS: Intl.DateTimeFormatOptions = {
  ...DATE_OPTIONS,
  hour: '2-digit',
  minute: '2-digit',
};

export const UI_COLORS = {
  lightMagenta: '#fff0f6',
  magenta: '#ffadd2',
  deepMagenta: '#eb2f96',
  lightRed: '#fff1f0',
  red: '#ffa39e',
  deepRed: '#f5222d',
  lightVolcano: '#fff2e8',
  volcano: '#ffbb96',
  deepVolcano: '#fa541c',
  lightOrange: '#fff7e6',
  orange: '#ffd591',
  deepOrange: '#fa8c16',
  lightGold: '#fffbe6',
  gold: '#ffe58f',
  deepGold: '#faad14',
  lightLime: '#fcffe6',
  lime: '#eaff8f',
  deepLime: '#a0d911',
  lightGreen: '#f6ffed',
  green: 'b7eb8f',
  deepGreen: '#52c41a',
  lightCyan: '#e6fffb',
  cyan: '#87e8de',
  deepCyan: '#13c2c2',
  lightBlue: '#e6f7ff',
  blue: '#91d5ff',
  deepBlue: '#1890ff',
  lightGeekblue: '#f0f5ff',
  geekblue: '#adc6ff',
  deepGeekblue: '#2f54eb',
  lightPurple: '#f9f0ff',
  purple: '#d3adf7',
  deepPurple: '#722ed1',
  lightGray: '#dddddd',
  gray: '#999999',
  deepGray: '#444444',
};

export enum TABLE_IDS {
  // Used to identify each table **uniquely** for saving
  // table state (filters, columns) to localStorage
  // If you create a new table, assign it a new ID
  REQ_PAGE_TABLE = 'reqTable',
  REQ_COURSES_TABLE = 'reqCoursesTable',
  REQ_PEOPLE_TABLE = 'reqPeopleTable',
  REQ_AUDIT_LOG = 'reqAuditLog',
  REQ_CATEGORIES_PAGE_TABLE = 'reqCategoriesTable',
  REQ_CATEGORY_REQS_TABLE = 'reqCategoryReqsTable',
  COURSES_PAGE_TABLE = 'coursesTable',
  COURSE_PEOPLE_TABLE = 'coursePeopleTable',
  COURSE_REQ_TABLE = 'courseReqTable',
  COURSE_AUDIT_LOG = 'courseAuditLog',
  PEOPLE_PAGE_TABLE = 'peopleTable',
  PERSON_TRANSCRIPTS_TABLE = 'personTranscriptsTable',
  PERSON_COURSES_TABLE = 'personCoursesTable',
  PERSON_EQUIVALENCIES_TABLE = 'personEquivalenciesTable',
  PERSON_GROUPS_TABLE = 'personGroupsTable',
  PERSON_AUDIT_LOG = 'personAuditLog',
  PERSON_AWARDS_TABLE = 'personAwardsTable',
  PERSON_PROTOCOLS_TABLE = 'personProtocolsTable',
  PERSON_ROLES_TABLE = 'personRolesTable',
  PERSON_OUTBOX_TABLE = 'personOutboxTable',
  PERSON_TENURES_TABLE = 'personTenuresTable',
  NOTIFICATIONS_PAGE_TABLE = 'notificationsTable',
  NOTIFICATIONS_AUDIT_LOG = 'notificationsAuditLog',
  TASKS_PAGE_TABLE = 'tasksTable',
  AUDIT_LOG_TABLE = 'auditLogTable',
  AUDIT_DETAIL_TABLE = 'auditDetailTable',
  REPORT_PAGE_TABLE = 'reportsTable',
  REPORT_REQUIREMENT_TABLE = 'reportsRequirementTable',
  REPORT_CATEGORY_TABLE = 'reportsCategoryTable',
  REPORT_COURSE_TABLE = 'reportsCourseTable',
  REPORT_RCR_TABLE = 'reportsRCRTable',
  OUTBOX_PAGE_TABLE = 'outboxTable',
  OUTBOX_AUDIT_LOG = 'outboxAuditLog',
  GROUPS_PAGE_TABLE = 'groupsTable',
  GROUP_PEOPLE_TABLE = 'groupPeopleTable',
  GROUP_AUDIT_LOG = 'groupAuditLog',
  TENURE_AUDIT_LOG = 'tenureAuditLog',
  TENURE_APPROVALS = 'tenureApprovals',
  TENURE_OUTBOX_TABLE = 'tenureOutboxTable',
  TENURE_REQUEST_AUDIT_LOG = 'tenureRequestAuditLog',
  TENURE_REQUESTS_TABLE = 'personTenureRequestsTable',
  TRANSCRIPTS_PAGE_TABLE = 'transcriptsPageTable',
  TRANSCRIPT_COURSES_TABLE = 'transcriptCoursesTable',
  TRANSCRIPT_AUDIT_LOG = 'transcriptAuditLog',
  EQUIVALENCIES_TABLE = 'equivalenciesTable',
  RULES_TABLE = 'rulesTable',
  TEMPLATES_TABLE = 'templatesTable',
  TEMPLATE_VERSIONS_TABLE = 'templateVersionsTable',
  TEMPLATE_AUDIT_LOG = 'templateAuditLog',
}

export const AUTH_ACTIONS = {
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
};

export enum COMMANDS {
  ACTIVATE_COURSE = 'activateCourse',
  ACTIVATE_REQUIREMENT = 'activateRequirement',
  ADD_COURSE_TO_PERSON = 'addCourseToPerson',
  ADD_AWARD_TO_PERSON = 'addAwardToPerson',
  ADD_COURSE_TO_REQUIREMENT = 'addCourseToRequirement',
  ADD_EXEMPTION_TO_PERSON = 'addExemptionToPerson',
  ADD_REQUIREMENT_TO_CATEGORY = 'addRequirementToCategory',
  ADD_REQUIREMENT_TO_PERSON = 'addRequirementToPerson',
  ADD_PERSON_TO_GROUP = 'addPersonToGroup',
  REMOVE_PERSON_FROM_GROUP = 'removePersonFromGroup',
  LINK_PERSON = 'linkPerson',
  UNLINK_PERSON = 'unlinkPerson',
  LINK_TRANSCRIPT = 'linkTranscript',
  UNLINK_TRANSCRIPT = 'unlinkTranscript',
  CREATE_UNLINKED_AALAS_ACCOUNT = 'createUnlinkedAALASAccount',
  CREATE_LINKED_AALAS_ACCOUNT = 'createLinkedAALASAccount',
  DEACTIVATE_COURSE = 'deactivateCourse',
  DEACTIVATE_REQUIREMENT = 'deactivateRequirement',
  LINK_EXTERNAL_ACCOUNT = 'linkExternalAccount',
  NEW_COURSE = 'createCourse',
  NEW_PERSON = 'newPerson',
  NEW_REQUIREMENT = 'newRequirement',
  CREATE_EQUIVALENCY = 'createEquivalency',
  UPDATE_COURSE = 'updateCourse',
  UPDATE_PERSON = 'updatePerson',
  UPDATE_PERSON_AWARD = 'updatePersonAward',
  UPDATE_REQUIREMENT = 'updateRequirement',
  UPDATE_EQUIVALENCY = 'updateEquivalency',
  BULK_IMPORT = 'bulkImport',
  REMOVE_AWARD_FROM_PERSON = 'removeAwardFromPerson',
  REMOVE_COURSE_FROM_PERSON = 'removeCourseFromPerson',
  REMOVE_COURSE_FROM_REQUIREMENT = 'removeCourseFromRequirement',
  REMOVE_EXEMPTION_FROM_PERSON = 'removeExemptionFromPerson',
  REMOVE_REQUIREMENT_FROM_CATEGORY = 'removeRequirementFromCategory',
  REMOVE_REQUIREMENT_FROM_PERSON = 'removeRequirementFromPerson',
  RERUN_REPORT = 'rerunReport',
  RETRY_NOTIFICATIONS = 'retryNotifications',
  SEND_TENURE_NOTIFICATION = 'sendTenureNotification',
  SEND_TENURE_REQUEST_NOTIFICATION = 'sendTenureRequestNotification',
  RESEND_MAIL = 'resendMail',
  RETRY_TASK = 'retryTask',
  RUN_IMPORT_TASK = 'runImportTask',
  RUN_REPORT = 'runReport',
  RUN_TASK = 'runTask',
  CREATE_TENURE = 'createTenure',
  EDIT_TENURE_LENGTH = 'editTenureLength',
  UPDATE_TENURE = 'updateTenure',
  CREATE_TENURE_REQUEST = 'createTenureRequest',
  UPDATE_TENURE_REQUEST = 'updateTenureRequest',
  APPROVE_TENURE_REQUEST = 'approveTenureRequest',
  UPDATE_APPROVAL_STATUS = 'updateApprovalStatus',
  UPDATE_PERSON_COURSE = 'updatePersonCourse',
  ADD_ATTACHMENTS_TO_APPROVAL_STATUS = 'addAttachmentsToApprovalStatus',
  REMOVE_ATTACHMENTS_FROM_APPROVAL_STATUS = 'removeAttachmentsFromApprovalStatus',
  ADD_PHYSICAL_ATTACHMENTS_TO_APPROVAL_STATUS = 'addPhysicalAttachmentsToApprovalStatus',
  REMOVE_PHYSICAL_ATTACHMENTS_FROM_APPROVAL_STATUS = 'removePhysicalAttachmentsFromApprovalStatus',
  ASSIGN_APPROVAL_TEMPLATES_TO_TENURE = 'assignApprovalTemplatesToTenure',
  UNASSIGN_APPROVAL_TEMPLATES_FROM_TENURE = 'unassignApprovalTemplatesFromTenure',
  ADD_ATTACHMENTS_TO_EQUIVALENCY = 'addAttachmentsToEquivalency',
  REMOVE_ATTACHMENTS_FROM_EQUIVALENCY = 'removeAttachmentsFromEquivalency',
  UPDATE_PERSON_PRIMARY_EMAIL = 'updatePersonPrimaryEmail',
  PUBLISH_TEMPLATE = 'publishTemplate',
  UPDATE_TEMPLATE_DRAFT = 'updateTemplateDraft',
  NEW_TEMPLATE = 'newTemplate',
  UPDATE_RULE_DRAFT = 'updateRuleDraft',
  PUBLISH_RULE = 'publishRule',
  CREATE_RULE = 'createRule',
  IMPERSONATE = 'impersonate',
  CANCEL_EMAIL_NOTIFICATION = 'cancelEmailNotification',
  UPDATE_SETTINGS = 'updateSettings',
  UPDATE_REQUIREMENT_DESCRIPTION = 'updateRequirementDescription',
  CREATE_REQUIREMENT_CATEGORY = 'createRequirementCategory',
  REMOVE_REQUIREMENT_CATEGORY = 'removeRequirementCategory',
}

export const reportsTypeNames = {
  requirementReport: 'Requirement Report',
  courseReport: 'Course Report',
  categoryReport: 'Requirement Category Report',
  rcrReport: 'RCR Tracking Report',
  tenureSponsorReport: `${CLIENT_CONST.TENURE_TERM} PI/Sponsor Report`,
};

export const modulesActionTypes = {
  MODULES_SUCCESS: 'MODULES_SUCCESS',
  MODULES_FAILURE: 'MODULES_FAILURE',
  MODULES_REQUEST: 'MODULES_REQUEST',
  MODULE_DETAILS_SUCCESS: 'MODULE_DETAIL_SUCCESS',
  MODULE_DETAILS_FAILURE: 'MODULE_DETAIL_FAILURE',
  MODULE_DETAILS_REQUEST: 'MODULE_DETAIL_REQUEST',
  MODULE_SELECT_SUCCESS: 'MODULE_SELECT_SUCCESS',
  MODULE_SELECT_FAILURE: 'MODULE_SELECT_FAILURE',
  MODULE_SELECT_REQUEST: 'MODULE_SELECT_REQUEST',
};
